import { FieldValues, Path } from "react-hook-form";

import { FormInput } from "../../../components/Input";
import { CardLabel, HelperText } from "../../../components/MobileForm/styles";
import {
  NOTE_HELPER,
  NOTE_LABEL,
  NOTE_PLACEHOLDER,
  noteRule,
} from "./constants";
import { NoteFieldProps } from "./types";

/**
 * The compact twin of `NoteField`. Copy and cap come from the same module its
 * desktop sibling reads, which is what stops the surfaces capping or wording one
 * field differently.
 */
export const MobileNoteField = <T extends FieldValues>({
  id,
  control,
  isSubmitting,
}: NoteFieldProps<T>) => (
  <>
    <CardLabel htmlFor={id}>{NOTE_LABEL}</CardLabel>
    <FormInput
      id={id}
      name={"note" as Path<T>}
      control={control}
      rules={noteRule}
      disabled={isSubmitting}
      placeholder={NOTE_PLACEHOLDER}
    />
    <HelperText>{NOTE_HELPER}</HelperText>
  </>
);
